/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactChatMessagesResponseData,
  GetContactChatMessagesResponseDataFromJSON,
  GetContactChatMessagesResponseDataFromJSONTyped,
  GetContactChatMessagesResponseDataToJSON
} from './GetContactChatMessagesResponseData'

/**
 *
 * @export
 * @interface GetChatMessagesResponse
 */
export interface GetChatMessagesResponse {
  /**
   *
   * @type {number}
   * @memberof GetChatMessagesResponse
   */
  status?: number
  /**
   *
   * @type {GetContactChatMessagesResponseData}
   * @memberof GetChatMessagesResponse
   */
  data?: GetContactChatMessagesResponseData
}

export function GetChatMessagesResponseFromJSON(json: any): GetChatMessagesResponse {
  return GetChatMessagesResponseFromJSONTyped(json, false)
}

export function GetChatMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChatMessagesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactChatMessagesResponseDataFromJSON(json['data'])
  }
}

export function GetChatMessagesResponseToJSON(value?: GetChatMessagesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactChatMessagesResponseDataToJSON(value.data)
  }
}
